export default function XSLT_Sort() {
  return (
    <div>
      <h1>XSLT_Sort</h1>
      <p>This is the XSLT_Sort component.</p>
    </div>
  );
}